import { ActivateCompanyConfirmationWebComponent } from './component/ActivateCompanyConfirmationWebComponent';
import { WEB_COMPONENT_ACTIVATE_COMPANY_CONFIRMATION } from '../../../webcomponents.constants';

export { ActivateCompanyConfirmationWebComponent };

window.customElements.define(WEB_COMPONENT_ACTIVATE_COMPANY_CONFIRMATION, ActivateCompanyConfirmationWebComponent);
